import styled from '@emotion/styled'
import { GatsbyImage } from 'gatsby-plugin-image'

export const Img = styled(GatsbyImage)`
  margin: 0 auto;

  img {
    ${(props) => `
      object-position: ${props?.position};
      aspect-ratio: ${props?.ratio};
      border-radius: ${props?.radius};
    `}
  }
`
